// extracted by mini-css-extract-plugin
export default {"wrap":"Card_wrap__Hw4sC","title":"Card_title__pjMxp","subtitle":"Card_subtitle__dtiAt"};